// The hero's visual: one rounded stage that holds a stack of alert cards (one per
// channel), the live "Today on Uptrack" counters and, rising from the bottom
// edge, the failed-check dashboard. Words sit on the left of the page and this
// stage on the right, so the page reads left to right. Owner-approved 2026-10-05;
// the 3D globe moved out of the hero on 2026-10-11 (it stays in the story section)
// and real live counters took its place.
'use client'

import { CatPeeking } from '@/components/mascot'
import { AlertStack } from './alert-stack'
import { LiveStats } from './live-stats'
import { ProductFrame } from './product-frame'

export function HeroStage() {
  return (
    <div className="dark relative">
      <div className="dark relative h-[500px] overflow-hidden rounded-frame border border-border bg-brand-dark text-foreground md:h-[560px]">
        <AlertStack
          responsive
          className="absolute left-5 top-5 z-10 w-[min(320px,calc(100%-2.5rem))] sm:w-[min(320px,calc(50%-1.875rem))]"
        />
        {/* Beside the alert cards on wide stages; under the stage on phones (see Hero). */}
        <LiveStats className="absolute right-5 top-5 z-10 hidden w-[min(310px,calc(50%-1.875rem))] sm:block" />
        {/* Peeks over the dashboard in the gap between the alert cards and the counters. */}
        <CatPeeking size={260} className="absolute left-1/2 top-[calc(50%-2.875rem)] z-0 h-auto w-32 -translate-x-1/2" />
        <div className="absolute inset-x-6 top-[calc(50%+0.625rem)]">
          <ProductFrame url="uptrack.app/dashboard/browser-checks/checkout-flow">
            <img
              src="/screenshots/hero-failed-check.webp"
              alt="A failed browser check in the Uptrack dashboard: step 4, Click Pay now, timed out in three regions."
              width={1184}
              height={640}
              fetchPriority="high"
              className="block h-auto w-full"
            />
          </ProductFrame>
        </div>
      </div>
    </div>
  )
}
